module.exports = __webpack_public_path__ + "img/imgImgHome05.0eda6377.svg";